export enum AccountType {
  STANDARD = 'STANDARD',
  ENTITY = 'ENTITY',
  ENTITY_WRITE = 'ENTITY_WRITE',
}